<template>
	<div id="platform">
		<header-menu curPage='platform'></header-menu>
		<div class="platform-section">
			<div class="title">平台优势</div>
			<div class="content-box" style="margin-top: 100px;">
				<div :class="platform1? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(1)">
					<div :class="platform1? 'item-title item-text-active' : 'item-title'">技术</div>
					<img class="icon" v-if="platform1" src="https://cdn.huimiaokeji.com/hjweb/icon_technology_90_2.png"/>
					<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_technology_90.png"/>
					<div :class="platform1? 'item-description item-text-active' : 'item-description'">多平台SDK竞价，高填充高收益。对接文档详尽专业，附带技术对接最佳实践</div>
					
				</div>
				<div :class="platform2? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(2)">
					<div :class="platform2? 'item-title item-text-active' : 'item-title'">能力</div>
					<img class="icon" v-if="platform2" src="https://cdn.huimiaokeji.com/hjweb/icon_ability_90_2png.png"/>
					<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_ability.png"/>
					<div :class="platform2? 'item-description item-text-active' : 'item-description'">双端：android/iOS</br/>
开发语言：java、flutter、h5、unity3D、cocos、uniapp</div>
				</div>
				<div :class="platform3? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(3)">
					<div :class="platform3? 'item-title item-text-active' : 'item-title'">结算</div>
					<img class="icon" v-if="platform3" src="https://cdn.huimiaokeji.com/hjweb/icon_balance_90_2.png"/>
					<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_balance.png"/>
					<div :class="platform3? 'item-description item-text-active' : 'item-description'">日结，周结，月结，预付</div>
				</div>
			</div>
			<div class="content-box" style="margin-top: 40px;">
				<div :class="platform4? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(4)">
					<div :class="platform4? 'item-title item-text-active' : 'item-title'">收益</div>
					<img class="icon" v-if="platform4" src="https://cdn.huimiaokeji.com/hjweb/icon_income_90_2.png"/> 
					<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_income.png"/>
					<div :class="platform4? 'item-description item-text-active' : 'item-description'">通过实时竞价，优质广告充分竞争，让每次请求获得最优收益配合自主的流量策略，灵活售卖，助力媒体取得最佳收益</div>
				</div>
				<div :class="platform5? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(5)">
					<div :class="platform5? 'item-title item-text-active' : 'item-title'">服务</div>
					<img class="icon" v-if="platform5"  src="https://cdn.huimiaokeji.com/hjweb/icon_service_90_2.png"/>
					<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_service.png"/>
					<div :class="platform5? 'item-description item-text-active' : 'item-description'">7x24小时随时在线解决您的一切疑问和顾虑</div>
				</div>
				<div :class="platform6? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(6)">
					<div :class="platform6? 'item-title item-text-active' : 'item-title'">性能</div>
					<img class="icon" v-if="platform6" src="https://cdn.huimiaokeji.com/hjweb/icon_stable_90_2.png"/>
					<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_stable.png"/>
					<div :class="platform6? 'item-description item-text-active' : 'item-description'">合作1000+APP高效稳定</div>
				</div>
			</div>
		</div>
		<footer-menu></footer-menu>
	</div>
</template>

<script>
	import HeaderMenu from '../components/header-menu.vue';
	import FooterMenu from '../components/footer-menu.vue';
	export default {
		name:'platform',
		components: {
			HeaderMenu,
			FooterMenu
		},
		data() {
			return {
				platform1: false,
				platform2: false,
				platform3: false,
				platform4: false,
				platform5: false,
				platform6: false,
				
			}
		},
		created() {
		  document.title = '灰鲸网络-平台优势';
		},
		methods: {
			handleMouseOver(flag) {
					if (flag == 1) {
						this.platform1 = true;
					} else if (flag == 2) {
						this.platform2 = true;
					} else if (flag == 3) {
						this.platform3 = true;
					} else if (flag == 4) {
						this.platform4 = true;
					} else if (flag == 5) {
						this.platform5 = true;
					} else if (flag == 6) {
						this.platform6 = true;
					}
			},
			// handleMouseOut(flag) {
			// 		  if (flag == 1) {
			// 		  	this.sdk1 = false;
			// 		  } else {
			// 		  	this.sdk2 = false;
			// 		  }
			// },
		}
	}
</script>

<style lang="less">
	#platform {
	  background-color: #FFFFFF;
	  .platform-section{
		  height: 820px;
		  background: #F3F7FF;
		  .title {
			  padding-top:100px;
			  font-family: PingFangSC, PingFang SC;
			  font-weight: bold;
			  font-size: 34px;
			  color: #0B00B5;
			  line-height: 34px;
			  text-align: center;
			  font-style: normal;
		  }
		  .content-box {
			  display: flex;
			  justify-content: space-between;
			  padding-left: 8%;
			  padding-right: 8%;
			  .content-item {
				  width: 373px;
				  height: 223px;
				  background: #FFFFFF;
				  position: relative;
				  .item-title {
					  padding-top: 40px;
					  padding-left: 40px;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: bold;
					  font-size: 24px;
					  color: #333333;
					  line-height: 24px;
					  text-align: left;
					  font-style: normal;
				  }
				  .item-description {
					  position:absolute;
					  width: 293px;
					  left: 40px;
					  top: 94px;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: 400;
					  font-size: 16px;
					  color: #666666;
					  line-height: 20px;
					  text-align: justify;
					  font-style: normal;
				  }
				  .icon {
					  position:absolute;
					  bottom: 0;
					  right: 0;
					  width: 90px;
					  height: 90px;
				  }
				  .item-text-active {
				  				  color: #FFFFFF;
				  }
			  }
			  .item-active {
				  background: #0B00B5;
			  }
			  
		  }
	  }
	  
	}
</style>


// WEBPACK FOOTER //
// src/pages/Platform.vue